<template>
  <h4>You are in partner page.</h4>
</template>
<script>
export default {
  mounted () {
    this.$emit('changeRouteTitle', 'Home')
  },
  data () {
    return {}
  }
}
</script>
